<div class="personal-main-container">
  <div class="personal-main-nav-bar box">
    <div class="personal-main-nav-bar-title">غذا های شخصی</div>
    <div class="personal-main-back img-holder" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="personal-main-top box">
    <div *ngIf="isReady && persoanlFood && persoanlFood.length == 0">
      <div class="empty-box">
        <img src="assets/general/emptyfood.svg" alt="" />
        <p class="titles">لیست غذاهای شخصی خالی است</p>
        <p class="descriptions">
          اگر غذایی را از بخش جست‌وجو پیدا نکردید اما اطلاعاتش را دارید،
          می‌توانید آن را به این لیست اضافه کنید.
        </p>
      </div>
      <div class="custome-button" (click)="goToAddFood()">
        <div class="add-icon">
          <img src="assets/plan/plus.svg" alt="" />
        </div>
        <p class="title">افزودن غذای جدید</p>
      </div>
    </div>
    <div *ngIf="isReady && persoanlFood && persoanlFood.length > 0">
      <div
        class="food-list-item"
        *ngFor="let food of persoanlFood; let last = last"
      >
        <p>
          {{ food.name }}
        </p>
        <div class="icons">
          <img
            src="assets/plans/plus.svg"
            (click)="openAndAddPersonalFood(food)"
            class="plus"
            alt=""
          />
          <img
            src="assets/plans/edit.svg"
            (click)="goToEditFood(food)"
            alt=""
          />
        </div>
      </div>
      <div class="add-button" (click)="goToAddFood()">
        <div class="">
          <img src="assets/plan/plus-white.svg" alt="" />
          <p>افزودن غذای شخصی</p>
        </div>
      </div>
    </div>
    <div *ngIf="!isReady">
      <div class="loading-input" *ngFor="let i of gArr(6)">
        <ngx-skeleton-loader
          [theme]="{
            top: '21px',
            right: '16px',
            height: '20px',
            width: '87px',
            position: 'absolute',
            'background-color': '#e8eaef'
          }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          [theme]="{
            top: '21px',
            left: '16px',
            height: '20px',
            width: '120px',
            position: 'absolute',
            'background-color': '#e8eaef'
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="add-button loading-button">
        <ngx-skeleton-loader
          [theme]="{
            height: '20px',
            width: '187px',
            'background-color': '#e8eaef'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>
